import type { RentalSearchQueryVariables } from 'graphql/generated'
import { buildPersonSearchPatterns, normalizePersonSearchText } from 'lib/person-search'

type RentalSearchQueryArgs = {
  variables: RentalSearchQueryVariables
  pause: boolean
}

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

export const buildRentalSearchQueryArgs = (searchText: string): RentalSearchQueryArgs => {
  const trimmedSearchText = searchText.trim()
  const normalizedSearchText = normalizePersonSearchText(searchText)
  const patterns = buildPersonSearchPatterns(searchText)

  return {
    variables: {
      query: `%${trimmedSearchText}%`,
      tenantNameQuery: patterns.combined,
      tenantFieldQuery: patterns.singleField,
      firstNameQuery: patterns.firstName,
      lastNameQuery: patterns.lastName,
      rentalIds: UUID_REGEX.test(trimmedSearchText) ? [trimmedSearchText] : []
    },
    pause: normalizedSearchText.length < 2
  }
}
